import { createModalsComponent } from 'modules/campaigns/lib/contexts/createModalContext';
import { CreativeLibraryPanel as CreativeLibraryPanelModal } from 'modules/creativeLibrary';
import { MovableInkPanel as MovableInkPanelModal } from 'modules/movableInk';
import { DynamicContentBuilder as DynamicContentBuilderModal } from 'modules/dynamicContentBuilder';
import { CreateOrEditSavedRowSlideOver } from './components/CreateOrEditSavedRowSlideOver';
import {
  DragAndDropEditorModalType,
  useDragAndDropEditorModalsContext,
} from './context/DragAndDropEditorModalsContext';
import { ManageCustomCategoriesModal } from './modals/ManageCustomCategoriesModal';
import { SavedRowUnsavedChangesModal } from './modals/SavedRowUnsavedChangesModal';
import { SavedRowUnsavedTemplateChangesWarning } from './modals/SavedRowUnsavedTemplateChangesWarning';

const MODAL_COMPONENTS_MAPPER = {
  [DragAndDropEditorModalType.DynamicContentBuilder]: DynamicContentBuilderModal,
  [DragAndDropEditorModalType.CreativeLibraryPanel]: CreativeLibraryPanelModal,
  [DragAndDropEditorModalType.MovableInkPanel]: MovableInkPanelModal,
  [DragAndDropEditorModalType.ManageCustomCategories]: ManageCustomCategoriesModal,
  [DragAndDropEditorModalType.CreateOrEditSavedRow]: CreateOrEditSavedRowSlideOver,
  [DragAndDropEditorModalType.SavedRowUnsavedTemplateChangesWarning]:
    SavedRowUnsavedTemplateChangesWarning,
  [DragAndDropEditorModalType.SavedRowUnsavedChanges]: SavedRowUnsavedChangesModal,
};

export const DragAndDropEditorModals = createModalsComponent<DragAndDropEditorModalType, any>(
  MODAL_COMPONENTS_MAPPER,
  useDragAndDropEditorModalsContext,
);
